import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useCurrency } from "../context/CurrencyContext";

export default function Cart() {
  const { cart, removeFromCart, increaseQty, decreaseQty } = useContext(CartContext);
  const { format, getShipping } = useCurrency();

  const subtotal     = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const shippingInfo = getShipping();
  const shippingCost = typeof shippingInfo === "object" ? shippingInfo.cost : shippingInfo;
  const itemCount    = cart.reduce((sum, item) => sum + item.quantity, 0);
  // NOTE: `total` variable removed — was flagged by ESLint (no-unused-vars).
  // Total is now rendered inline as format(subtotal) + shipping display string.

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&family=DM+Sans:wght@300;400;500&display=swap');

        .ct-root *, .ct-root *::before, .ct-root *::after { box-sizing:border-box; margin:0; padding:0; }
        .ct-root {
          font-family:'DM Sans',sans-serif;
          background:#fdf9f6;
          min-height:80vh;
          padding:32px 28px 64px;
          max-width:800px;
          margin:0 auto;
        }
        @media(max-width:600px){.ct-root{padding:20px 14px 48px}}

        .ct-eyebrow {
          font-size:9px;font-weight:500;letter-spacing:.26em;
          text-transform:uppercase;color:#c87090;
          margin-bottom:5px;display:block;
        }
        .ct-title {
          font-family:'Cormorant Garamond',serif;
          font-size:clamp(22px,4vw,32px);
          font-weight:300;color:#1a1410;
          letter-spacing:-.01em;display:block;
          margin-bottom:24px;
        }

        .ct-empty { text-align:center; padding:56px 20px; }
        .ct-empty-icon {
          font-family:'Cormorant Garamond',serif;
          font-size:48px;color:#ede8e2;
          line-height:1;display:block;margin-bottom:12px;
        }
        .ct-empty-title {
          font-family:'Cormorant Garamond',serif;
          font-size:22px;font-weight:300;color:#1a1410;
          display:block;margin-bottom:6px;
        }
        .ct-empty-sub {
          font-size:13px;font-weight:300;color:#a09890;
          display:block;margin-bottom:20px;
        }
        .ct-empty-btn {
          display:inline-block;
          background:#1a1410;color:#fdf9f6;
          font-size:10px;font-weight:500;
          letter-spacing:.16em;text-transform:uppercase;
          text-decoration:none;
          padding:10px 24px;
          transition:background .2s;
        }
        .ct-empty-btn:hover{background:#c87090}

        .ct-item {
          display:grid;
          grid-template-columns:64px 1fr auto auto auto;
          align-items:center;
          gap:12px;
          padding:14px 0;
          border-bottom:1px solid #f0ebe5;
        }
        @media(max-width:500px){
          .ct-item{ grid-template-columns:52px 1fr; grid-template-rows:auto auto; gap:8px; }
        }

        .ct-item-img { width:64px;height:64px;object-fit:cover;display:block;background:#f0ebe5; }
        @media(max-width:500px){.ct-item-img{width:52px;height:52px}}

        .ct-item-name {
          font-family:'Cormorant Garamond',serif;
          font-size:15px;font-weight:400;color:#1a1410;
          display:block;line-height:1.2;margin-bottom:2px;
        }
        .ct-item-meta { font-size:11px;font-weight:300;color:#a09890;display:block; }
        .ct-item-price-unit { font-size:12px;font-weight:500;color:#c87090;white-space:nowrap; }

        .ct-qty { display:flex;align-items:center;gap:0;border:1px solid #ede8e2; }
        .ct-qty-btn {
          width:26px;height:26px;background:none;border:none;
          font-size:14px;color:#5a524c;cursor:pointer;
          display:flex;align-items:center;justify-content:center;
          transition:background .15s;font-family:'DM Sans',sans-serif;
        }
        .ct-qty-btn:hover{background:#f0ebe5}
        .ct-qty-num {
          width:28px;text-align:center;font-size:12px;font-weight:500;color:#1a1410;
          border-left:1px solid #ede8e2;border-right:1px solid #ede8e2;line-height:26px;
        }

        .ct-item-subtotal { font-size:12px;font-weight:500;color:#1a1410;white-space:nowrap;min-width:72px;text-align:right; }

        .ct-remove {
          font-size:10px;font-weight:400;color:#c9b8b2;
          background:none;border:none;cursor:pointer;
          text-decoration:underline;font-family:'DM Sans',sans-serif;
          transition:color .15s;white-space:nowrap;
        }
        .ct-remove:hover{color:#c87090}

        @media(max-width:500px){
          .ct-qty,.ct-item-subtotal,.ct-remove,.ct-item-price-unit{ grid-column:2; }
          .ct-item-row2{ grid-column:2;display:flex;align-items:center;gap:10px;flex-wrap:wrap; }
        }

        .ct-summary { margin-top:24px;background:#fff;border:1px solid #ede8e2;padding:18px 20px; }
        .ct-summary-title {
          font-family:'Cormorant Garamond',serif;
          font-size:18px;font-weight:300;color:#1a1410;
          display:block;margin-bottom:14px;letter-spacing:-.01em;
        }
        .ct-summary-row { display:flex;justify-content:space-between;font-size:12px;font-weight:300;color:#7a6e68;margin-bottom:6px; }
        .ct-summary-divider { border:none;border-top:1px solid #f0ebe5;margin:10px 0; }
        .ct-summary-total { display:flex;justify-content:space-between;font-size:14px;font-weight:500;color:#1a1410;margin-bottom:16px; }
        .ct-checkout-btn {
          display:block;width:100%;background:#1a1410;color:#fdf9f6;
          font-family:'DM Sans',sans-serif;font-size:10px;font-weight:500;
          letter-spacing:.18em;text-transform:uppercase;text-align:center;
          padding:12px;border:none;cursor:pointer;text-decoration:none;transition:background .2s;
        }
        .ct-checkout-btn:hover{background:#c87090}
        .ct-continue {
          display:block;text-align:center;margin-top:10px;
          font-size:11px;font-weight:300;color:#a09890;text-decoration:none;transition:color .15s;
        }
        .ct-continue:hover{color:#c87090}
      `}</style>

      <div className="ct-root">
        <span className="ct-eyebrow">Your Bag</span>
        <span className="ct-title">Shopping Cart</span>

        {cart.length === 0 && (
          <div className="ct-empty">
            <span className="ct-empty-icon">✦</span>
            <span className="ct-empty-title">Your cart is empty</span>
            <span className="ct-empty-sub">Looks like you haven't added anything yet.</span>
            <a href="/products" className="ct-empty-btn">Continue Shopping</a>
          </div>
        )}

        {cart.map((item) => (
          <div key={item._cartKey} className="ct-item">
            <img src={item.image} alt={item.name} className="ct-item-img" />
            <div className="ct-item-info">
              <span className="ct-item-name">{item.name}</span>
              <span className="ct-item-meta">
                {item.selectedSize ? `Size: ${item.selectedSize}` : ""}
                {item.selectedSize && item.selectedColor ? " · " : ""}
                {item.selectedColor ? `Color: ${item.selectedColor}` : ""}
              </span>
              <span className="ct-item-price-unit">{format(item.price)}</span>
            </div>
            <div className="ct-qty">
              <button className="ct-qty-btn" onClick={() => decreaseQty(item._cartKey)}>−</button>
              <span className="ct-qty-num">{item.quantity}</span>
              <button className="ct-qty-btn" onClick={() => increaseQty(item._cartKey)}>+</button>
            </div>
            <span className="ct-item-subtotal">{format(item.price * item.quantity)}</span>
            <button className="ct-remove" onClick={() => removeFromCart(item._cartKey)}>Remove</button>
          </div>
        ))}

        {cart.length > 0 && (
          <div className="ct-summary">
            <span className="ct-summary-title">Order Summary</span>

            <div className="ct-summary-row">
              <span>Subtotal ({itemCount} items)</span>
              <span>{format(subtotal)}</span>
            </div>

            <div className="ct-summary-row">
              <span>Shipping{shippingInfo?.label ? ` · ${shippingInfo.label}` : ""}</span>
              <span style={{ color: "#10b981", fontWeight: 500 }}>
                {shippingCost === 0
                  ? "Free"
                  : shippingInfo?.display || format(shippingCost)}
              </span>
            </div>

            <hr className="ct-summary-divider" />

            <div className="ct-summary-total">
              <span>Total</span>
              <span>
                {format(subtotal)}
                {shippingCost > 0 ? ` + ${shippingInfo?.display}` : ""}
              </span>
            </div>

            <a href="/checkout" className="ct-checkout-btn">Proceed to Checkout</a>
            <a href="/products" className="ct-continue">← Continue Shopping</a>
          </div>
        )}
      </div>
    </>
  );
}